import { Search } from "@mui/icons-material";
import {
  Autocomplete,
  FormControl,
  IconButton,
  InputAdornment,
  Popper,
  TextField,
} from "@mui/material";
import { CustomTooltip } from "components/RosterConfig/RosterConfigStyle";
import SnackBar from "components/SnackBar/SnackBar";
import BackdropComponent from "components/Spinner/Spinner";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { searchEmployeeProfile } from "services/userServices";
import { SnackBarStoreAction } from "Store/SnackBar";
import PropTypes from "prop-types";
import { isStringNullOrEmpty } from "../utilities";
export const CustomPopper = (props) => {
  return <Popper {...props} placement="bottom-start" />;
};

export const employeeSearchResultinitialState = {
  OracleId: "",
  Display: "",
  Name: "",
  Email: "",
};
export default function EmployeeSearch(props) {
  const {
    onChange,
    placeholder,
    label,
    onReset,
    defaultEmployeeName,
    isError,
    clearFields, //A field to clear the search results and text input.
  } = props;
  const [loading, setLoading] = useState(false);
  const [employeeResults, setEmployeeResults] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState({
    OracleId: null,
    Name: "",
    Email: defaultEmployeeName,
    Display: defaultEmployeeName,
  });

  useEffect(() => {
    setEmployeeResults([]);
    setSelectedEmployee({
      OracleId: null,
      Name: "",
      Email: "",
    });
  }, [clearFields]);

  useEffect(() => {
    if (defaultEmployeeName && defaultEmployeeName != "") {
      handleEmployeeSearch("", defaultEmployeeName);
    }
  }, [defaultEmployeeName]);

  const dispatch = useDispatch();

  const showSnack = (message, severity) => {
    const obj = {
      open: true,
      message: message,
      severity: severity,
    };
    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleEmployeeSearchInputChange = (key, value) => {
    setSelectedEmployee((prevState) => ({ ...prevState, [key]: value }));
  };

  const handleEmployeeSelected = (event, value) => {
    if (value) {
      setSelectedEmployee({
        OracleId: value.OracleId,
        Name: value.Name,
        Email: value.Email,
      });
      onChange(value);
    }
  };

  const handleEmployeeSearch = async (event, searchQuery) => {
    if (searchQuery) {
      if (searchQuery.length < 3) {
        showSnack(
          "Search criteria must be at least 3 characters in length.",
          "error"
        );
        return;
      }
      setLoading(true);
      const searchResult = await searchEmployeeProfile(searchQuery);
      if (searchResult.status === true) {
        let searchResultDetails;

        if (!isNaN(searchQuery)) {
          searchResultDetails = searchResult.data.map((emp) => ({
            OracleId: emp.OracleId,
            Display:
              (emp.Name ?? "") + (emp.OracleId ? ` (${emp.OracleId})` : ""),
            Name: emp.Name?.toLowerCase(),
            Email: emp.Email,
          }));
        } else {
          searchResultDetails = searchResult.data.map((emp) => ({
            OracleId: emp.OracleId,
            Display: emp.Display,
            Name: emp.Name?.toLowerCase(),
            Email: emp.Email,
          }));
        }

        setEmployeeResults(searchResultDetails);
        if (isStringNullOrEmpty(defaultEmployeeName)) {
          showSnack("Results found matching the search criteria.", "success");
        } else {
          handleEmployeeSelected("", searchResultDetails[0]);
        }
      } else {
        setSnack("No result found matching with search criateria.", "error");
      }
      setLoading(false);
    }
  };

  const handleReset = (event, value) => {
    if (value === "") {
      onReset();
      setSelectedEmployee({
        OracleId: null,
        Name: "",
        Email: "",
      });
    }
  };

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <FormControl fullWidth>
        <Autocomplete
          freeSolo
          label={label}
          required
          options={employeeResults}
          getOptionLabel={(option) => option.Display || ""}
          onInputChange={handleReset}
          onChange={handleEmployeeSelected}
          inputValue={selectedEmployee.Name || ""}
          PopperComponent={CustomPopper}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              variant="outlined"
              error={isError}
              placeholder={placeholder}
              value={selectedEmployee.Name || ""}
              onChange={(event) =>
                handleEmployeeSearchInputChange("Name", event.target.value)
              }
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  handleEmployeeSearch(event, selectedEmployee.Name);
                }
              }}
              InputProps={{
                maxLength: 50,
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    <CustomTooltip title={"Search"}>
                      <IconButton
                        id="icon-button-search"
                        type="button"
                        onClick={(event) =>
                          handleEmployeeSearch(event, selectedEmployee.Name)
                        }
                        color="primary"
                      >
                        <Search />
                      </IconButton>
                    </CustomTooltip>
                    {params.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </FormControl>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
}

EmployeeSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onReset: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  defaultEmployeeName: PropTypes.string.isRequired,
  isError: PropTypes.bool,
  clearFields: PropTypes.number,
};
